import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

export const fetchCaseStudyList = async () => {
  const response = await axios.get(`${API_BASE_URL}/case-studies`);
  return response.data?.items || [];
};

export const fetchCaseStudyById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/case-studies/${id}`);
  return response.data;
};

export const createCaseStudy = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/case-studies`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const updateCaseStudy = async (id, payload) => {
  const response = await axios.put(
    `${API_BASE_URL}/case-studies/${id}`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const deleteCaseStudy = async (id) => {
  await axios.delete(`${API_BASE_URL}/case-studies/${id}`, getAuthConfig());
};

export const uploadCaseStudiesJson = async (items) => {
  const response = await axios.post(
    `${API_BASE_URL}/case-studies/upload/json`,
    { items },
    getAuthConfig(),
  );

  return response.data;
};
